<template>
	<div class="login" :style="winSize">
		<Form ref="formCustom" class="login_box" :model="formCustom" :rules="ruleCustom" :label-width="40" :style="formOffset">
	        <Form-item label="账号" prop="username">
	            <Input type="text" v-model="formCustom.username">
                    <Icon type="ios-person-outline" slot="prepend"></Icon>   
                </Input>
	        </Form-item>
	        <Form-item label="密码" prop="password">
	            <Input type="password" v-model="formCustom.password">
                    <Icon type="ios-locked-outline" slot="prepend"></Icon>
                </Input>
	        </Form-item>
	        <Form-item>
	            <Button type="primary" @click="handleSubmit('formCustom')">登录</Button>
	            <Button type="ghost" @click="handleReset('formCustom')" style="margin-left: 8px">重置</Button>
	        </Form-item>
	    </Form>
	</div>
</template>
<script>
    import { mapState } from 'vuex'
	export default{
		data(){
			const usernameFn = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入用户名'));
                }else{
                	callback();
                }
            };
            const passwordFn = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }else{
                	callback();
                }
            };
            
            return {
                formCustom: {
                    username: '',
                    password: '',
                },
                ruleCustom: {
                    username: [
                        { validator: usernameFn, trigger: 'blur' },
                    ],
                    password: [
                        { validator: passwordFn, trigger: 'blur' }
                    ]
                },
                winSize: {
                    width:'',
                    height:''
                },
                formOffset: {
                    position:'absolute',
                    left:'',
                    top:''
                },
            }
		},
		created(){
        	this.setSize();
        	window.addEventListener('resize',this.setSize);
        },
		methods:{
			setSize() {
                this.winSize.height = document.documentElement.clientHeight + "px";

                this.winSize.width = document.documentElement.clientWidth + "px";

                this.formOffset.left = (parseInt(this.winSize.width) / 2 - 175) + 'px';

                this.formOffset.top = (parseInt(this.winSize.height) / 2 - 178) + 'px';
            },
        	handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                    	var _this=this;
	                    this.$http.get('/web/login/loginCheck',{
	                        params:_this.formCustom
	                    }).then(function(res){
	                        if(res.success){
                                //_this.$store.dispatch('rightFn',res.data.aid);
                                //_this.$store.state.rightId=res.data.aid;
                                localStorage.setItem('aid',res.data.aid);
                                localStorage.setItem('name',res.data.name);
                                localStorage.setItem('departmentid',res.data.departmentid);
                                localStorage.setItem('position',res.data.position);
                                localStorage.setItem('type',res.data.type);
                                _this.$router.push({path:'/home'});
                                _this.$Notice.success({
                                    title: '登录',
                                    desc:res.message
                                });
	                        }else{
                                _this.$Notice.error({
                                    title: '登录',
                                    desc:res.message
                                });
                            }
	                    }).catch(function(err){
	                    	_this.$Notice.error({
                                title: '登录',
                                desc: '操作失败'
                            });
	                    });
                    } else {
                        this.$Message.error('表单验证失败!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
		}
	}
</script>
<style scoped>
	.login{
		background:#1F2D3D;
	}
	.login_box{
		width: 350px;
       	padding: 35px 35px 15px 35px;
		box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin-bottom: 20px;
        background-color: #F9FAFC;
        border: 2px solid #8492A6;
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue